import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppStateService } from '../../../services/app-state.service';
import { WidgetService } from '../../../services/widget.service';
import { DisplayService } from '../../../services/display.service';

@Component({
  selector: 'app-pre-questions',
  templateUrl: './pre-questions.component.html',
  styleUrls: ['./pre-questions.component.scss']
})
export class PreQuestionsComponent implements OnInit {

  userProfile = "";
  goalAnswerIndex;
  userProfileIndex;
  goalAnswers = [
    'Body Mind Integration: More balance, greater fulfillment, deeper connections',
    'Work Performance Enhancement: more creativity, better focus and concentration, higher productivity',
    'High Performance Living: fulfilling a mission, seeking adventure, enhancing consciousness'
  ];
  profiles = [
    'A Professional',
    'An Executive',
    'An Entrepreneur',
    'Other'
  ];
  categoryList = [];
  userForm: FormGroup;
  checked = false;
  activePreQuestion = 1;

  constructor(
    private stateService: AppStateService,
    private fb: FormBuilder,
    private route: Router,
    private service: WidgetService,
    private display: DisplayService
  ) {
    this.stateService.getCategoryList().subscribe(cat => {
      this.categoryList = cat;
    });
  }


  ngOnInit(): void {
    this.userForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', []],
      email: ['', [Validators.email, Validators.required]],
      phone: ['', []],
    });
  }

  setProfile(index: number) {
    this.userProfileIndex = index;
    this.activePreQuestion = 2;
  }

  get f() { return this.userForm.controls; }

  setGoalIndex(index: number) {
    this.goalAnswerIndex = index;
    this.activePreQuestion = 3;
  }

  onClickBack(index: number) {
    this.activePreQuestion = index;
  }

  onSave() {
    if (this.userForm.valid) {
      this.display.showLoader();
      const userData = { ...this.userForm.value, profile: this.profiles[this.userProfileIndex], goal: this.goalAnswers[this.goalAnswerIndex] };
      this.service.saveContact(userData).subscribe(res => {
        if (res && res.data) {
          localStorage.setItem('user', res.data._id);
          localStorage.setItem('predata', JSON.stringify(res.data));
          this.route.navigate([`/pages/quiz/${this.categoryList[0]}`])
        }
        this.display.hideLoader();
      }, err => {
        this.display.hideLoader();
        console.log(err);
      })

    }
  }

}
